import React, { useContext, useEffect } from 'react';

import { MenuHeader } from 'src/modules/designStudio/components/DesignMenu/Menu/MenuHeader';
import { WallGroupMenu } from 'src/modules/designStudio/components/DesignMenu/Menu/WallGroupMenu';
import { Menu as MenuConstants } from 'src/modules/designStudio/constants';
import { getGuardedLegacyConfig } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import { historyContext } from 'src/modules/designStudio/providers';
import { FeatureFlag } from 'src/shared/constants';
import { useTreatment } from 'src/shared/hooks/useSplit';

import { InspireMeMenu } from './InspireMeMenu';
import { InteractiveRenderingRoofRegionsMenu } from './InteractiveRenderingRoofMenu';
import { InteractiveRenderingTrimRegionsMenu } from './InteractiveRenderingTrimMenu';
import { InteractiveRenderingWallRegionsMenu } from './InteractiveRenderingWallMenu';
import { RoofMenu } from './RoofMenu';
import { TemplateMenu } from './Templates/TemplateMenu';
import { TrimMenu } from './TrimMenu';
import { WindowMenu } from './WindowMenu';

const MenuComponentMap = {
  [MenuConstants.TRIM]: TrimMenu,
  [MenuConstants.WALL]: WallGroupMenu,
  [MenuConstants.ROOF]: RoofMenu,
  [MenuConstants.WINDOW]: WindowMenu,
  [MenuConstants.INTERACTIVE_RENDERING_WALL]:
    InteractiveRenderingWallRegionsMenu,
  [MenuConstants.INTERACTIVE_RENDERING_ROOF]:
    InteractiveRenderingRoofRegionsMenu,
  [MenuConstants.INTERACTIVE_RENDERING_TRIM]:
    InteractiveRenderingTrimRegionsMenu,
  [MenuConstants.TEMPLATE]: TemplateMenu,
  [MenuConstants.ACCENT]: null,
  [MenuConstants.DOOR]: null,
  [MenuConstants.ACCENT]: null,
  [MenuConstants.VERSION]: null,
  [MenuConstants.RESET]: null,
  [MenuConstants.SHARE]: null,
  [MenuConstants.SHOW_DESIGN]: null,
  [MenuConstants.INSPIRE_ME]: InspireMeMenu,
};

export const Menu = ({
  menu,
  requestingOrgName,
  headerText,
  closeMenu,
}: {
  menu: MenuConstants | null;
  requestingOrgName?: string;
  headerText: string | null;
  closeMenu: () => void;
}) => {
  const { historyState, updateDesign } = useContext(historyContext);
  const designConfig = getGuardedLegacyConfig(historyState.designConfig);

  const shouldPostMessageEvents = useTreatment(
    FeatureFlag.DesignStudio.DS_PROTOTYPE_POST_MESSAGE_EVENTS,
  );

  // @ts-ignore
  const wrappedUpdateDesign = update => {
    // See DS-846
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    updateDesign(update);

    window.parent.postMessage(`update: ${JSON.stringify(update)}`, '*');
  };

  useEffect(() => {
    if (shouldPostMessageEvents) {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      window.parent.postMessage(`menu: ${menu}`, '*');
    }
  }, [menu, shouldPostMessageEvents]);

  const MenuComponent = menu && MenuComponentMap[menu];

  if (!MenuComponent)
    return <MenuHeader closeMenu={closeMenu} headerText={headerText ?? ''} />;

  return (
    <MenuComponent
      closeMenu={closeMenu}
      designConfig={designConfig}
      headerText={headerText}
      requestingOrgName={requestingOrgName}
      updateDesign={
        shouldPostMessageEvents ? wrappedUpdateDesign : updateDesign
      }
    />
  );
};
